package com.example.blogmultiplatform.pages.about

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page


/*
* BlogMultiplatform.com.example.blogmultiplatform.pages.about
* Created by SAMET BAYAT 
* on 29.07.2024 at 1:47 AM
* Copyright (c) 2024 UNITED WORLD. All rights reserved.
*/




@Page
@Composable
fun AboutPage() {



}

